import 'proxy-polyfill';
import { createRoot } from 'react-dom/client';
import App from './App';
import { clarityService } from './services/clarityService';
import { tokenRefreshService } from './services/tokenRefreshService';
import { initializeConsoleLogCollection } from './utils/bugReportUtils';
import { globalErrorHandler } from './utils/globalErrorHandler';

// Initialize console log collection for bug reporting
initializeConsoleLogCollection();

// Initialize global error handler
globalErrorHandler.initialize();

// Set up a placeholder for bug report trigger (will be replaced by React component)
// This ensures the function exists even if React hasn't mounted yet
(window as any).__triggerBugReport = () => {
  console.warn(
    'BugReportDialog trigger called but React not ready yet. Dispatching event...'
  );
  // Dispatch custom event as fallback
  window.dispatchEvent(new CustomEvent('triggerBugReport'));
};

// Initialize Clarity tracking
clarityService.init();

// Start automatic token refresh
tokenRefreshService.start();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);
root.render(<App />);
